import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-message-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
  ],
  template: `
    <h2 mat-dialog-title>Read this to the customer: </h2>
    <mat-dialog-content>
      <p>To complete your registration, please follow these steps:</p>
      <ol>
        <li>Check your email inbox.</li>
        <li>Click on the link provided and set your new password.</li>
        <li>Once that’s done, you can log in using your email and password.</li>
      </ol>
      <p>Let us know if you need any help!</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Close</button>
    </mat-dialog-actions>
  `,
})
export class MessageDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}